<template>
  <div class="workflow shadow3 border-radius-sm overflow-hidden">
    <OpaqueCardHeaderWithTabs :tabs="tabs" />

    <div class="card-content bg-white-1 q-px-xl q-pt-lg q-pb-xl">
      <div class="text-subtitle-1 text-secondary-1 q-pb-md">WORKFLOW <HelpPageBtn :page="__guide.workflowIntro" /></div>
      <TasksWrapper from="dashboard" />
    </div>
  </div>
</template>

<script>
// Components
import HelpPageBtn from '@/reusable/base-components/HelpPageBtn'
import OpaqueCardHeaderWithTabs from '@/ui/OpaqueCardHeaderWithTabs'
import TasksWrapper from '@/reusable/workflow/TasksWrapper'

export default {
  components: {
    HelpPageBtn,
    OpaqueCardHeaderWithTabs,
    TasksWrapper
  },

  data: () => ({
    tabs: [{ id: 1, name: 'Dashboard', route: {} }]
  })
}
</script>
